import { sessionStorage } from "@web-monorepo/safe-browser-storage";

const LOGIN_REDIRECT_KEY = "marketplaceLoginRedirect";

export function setLoginRedirect(url: string) {
  sessionStorage.setItem(LOGIN_REDIRECT_KEY, url);
}

export function getLoginRedirect(): string | undefined {
  return sessionStorage.getItem(LOGIN_REDIRECT_KEY) ?? undefined;
}

export function clearLoginRedirect() {
  sessionStorage.removeItem(LOGIN_REDIRECT_KEY);
}

/**
 * Saves the current location so the user is returned here after logging in.
 *
 * Used by the systemic auth entry points (the RequireLoggedIn guard and the
 * global 401 handlers) before sending the user to login. We only save when a
 * redirect isn't already set, so an explicit `setLoginRedirect` from a specific
 * flow (favorites, referrals, etc.) — or an earlier capture — wins, and a 401
 * that fires again from the login page itself can't overwrite the target.
 *
 * The full `href` (including the hash) is stored because marketplace uses hash
 * routing; `usePostLoginRedirect` reads the hash back out to restore the route.
 */
export function setLoginRedirectIfUnset() {
  if (!getLoginRedirect()) {
    setLoginRedirect(window.location.href);
  }
}
